import styled from 'styled-components';
import { BxpButton, BxpLink } from './link-button/link-button.styles';
import { spacing as spacingDefinitions, minWidth } from '../styles';
export const Stack = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ spacing = 'none' }) => spacingDefinitions[spacing]};

  ${({ orientation }) => orientation === 'horizontal' &&
    `
    @media ${minWidth.md} {
      flex-direction: row;

      > ${BxpButton}:last-child,
      > ${BxpLink}:last-child {
        margin-left: auto;
      }
    }
  `}

  /* Apply margin-top "stick to bottom" rule only when no verticalAlign is set AKA align-items: stretch */
  ${({ fullHeight, verticalAlign }) => {
    let heightStyles = '';
    if (!!fullHeight) {
        heightStyles += 'height: 100%;';
        if (!(verticalAlign === null || verticalAlign === void 0 ? void 0 : verticalAlign.length)) {
            heightStyles += `
          > ${BxpButton}:last-child,
          > ${BxpLink}:last-child {
            margin-top: auto;
            padding-top: 1rem;
          }
        `;
        }
    }
    return heightStyles;
}}
  ${({ orientation, verticalAlign }) => {
    if (orientation === 'horizontal') {
        switch (verticalAlign) {
            case 'Top':
                return 'align-items: start;';
            case 'Bottom':
                return 'align-items: end;';
            default:
                return 'align-items: center;';
        }
    }
    else {
        switch (verticalAlign) {
            case 'Top':
                return 'justify-content: start;';
            case 'Bottom':
                return 'justify-content: end;';
            case 'Middle':
                return 'justify-content: center;';
            default:
                return 'justify-content: space-between;';
        }
    }
}}
`;
//# sourceMappingURL=Stack.js.map